import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const userLogService = {
    /**
     * Get user session logs with filters
     */
    getUserLogs: async (filters = {}) => {
        try {
            const response = await axios.get(`${API_URL}/user-logs`, {
                params: filters,
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching user logs:', error);
            throw error;
        }
    },

    /**
     * Export session logs as CSV
     */
    exportUserLogsCsv: async (filters = {}) => {
        try {
            const response = await axios.get(`${API_URL}/user-logs/export`, {
                params: filters,
                withCredentials: true,
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Error exporting user logs:', error);
            throw error;
        }
    }
};

export default userLogService;
